import {getUrlParameter, replaceUrlParam, replaceQueryParam, removeQueryParam} from '@js/helpers/location';
import {refreshPageWithParams} from '@js/modules/public/rankings/institutional/view/helpers';

export default function initAppliedFiltersListeners() {
    $('body')
        .on('click', '.remove-all-applied-filters', () => {
            let activeFilters = $(window.location).attr('href').split('?')[1];
            const appliedVisibleFilters = $('button.remove-applied-filter');
            appliedVisibleFilters.each((selectedFilter) => {
                const filterName = $(appliedVisibleFilters[selectedFilter]).attr('data-filter');
                const isMultiple = $(appliedVisibleFilters[selectedFilter]).attr('data-multiple') === 'true';
                if (isMultiple) {
                    const urlParamValues = getUrlParameter(filterName);
                    let replacementValue = urlParamValues.filter((item) => item !== item);
                    activeFilters = replaceQueryParam(activeFilters, filterName, replacementValue);
                } else {
                    activeFilters = removeQueryParam(activeFilters, filterName);
                }
            });
            refreshPageWithParams(activeFilters);
        })
        .on('click', '.remove-applied-filter', function () {
            const isMultiple = $(this).data('multiple') === true;
            const filterName = $(this).data('filter');
            let replacementValue;
            if (isMultiple) {
                const multipleFilterValue = $(this).data('multiple-value');
                const urlParamValues = getUrlParameter(filterName);
                replacementValue = urlParamValues.filter((item) => item != multipleFilterValue);
            } else {
                replacementValue = '';
            }
            window.location.search = replaceUrlParam(filterName, replacementValue);
        });
}
